import { installGlobalErrorHandler } from "@main/app/global-error-handler";
import { initSentry } from "@main/infra/sentry";
import { render } from "solid-js/web";
import { App } from "./app";
import "uplot/dist/uPlot.min.css";
import "./app.css";

initSentry();
installGlobalErrorHandler();

const mount = document.getElementById("root");
if (!mount) {
  throw new Error("root element not found");
}

render(() => <App />, mount);
